module.exports = __webpack_public_path__ + "static/media/adaptive.e88adc21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/adaptive.svg
// module id = 263
// module chunks = 0